module.exports = __webpack_public_path__ + "media/images/xpass/icons/favorite-unselected-281b579ea0ef43c3f9101bbd55368483.svg";